import React, { useState } from 'react'
import moment from 'moment'

import { Button, Text, DurationInput } from '@components/UI'
import { Heap } from '@helpers'

const Duration = ({ duration, overtime, small, onSubmit }) => {
  const [value, setValue] = useState(
    moment.duration({ minutes: duration + overtime })
  )
  const [error, setError] = useState(null)

  return (
    <div>
      <Text
        className={`${small ? 'text-c' : 'text-e'}`}
        style={{
          color: 'rgba(255, 255, 255, .45)'
        }}
      >
        How long did the session actually last?
      </Text>
      {!!error && (
        <Text className='error' style={{ marginTop: 6 }}>
          *{error}
        </Text>
      )}

      <DurationInput
        value={moment.duration({ minutes: duration + overtime })}
        update={(duration) => setValue(duration)}
        style={{ margin: 'auto', marginTop: 16 }}
        events={{ onFocus: () => setError(null) }}
      />
      <div className='actions-container'>
        <Button
          className='medium'
          theme='c interactive'
          inverted
          group={small ? 'a3' : 'a4'}
          icon={{
            name: 'check',
            value: 'Confirm',
            group: small ? 'a' : 'a2'
          }}
          events={{
            onClick: () => {
              if (value.asMinutes() === 0) {
                Heap.trigger('Classroom Feedback Duration - Submit - 0')
                setError('please input a non-zero duration')
                return
              }

              const max = moment.duration(duration + 180, 'minutes')
              const maxDuration = `${
                max.hours() < 10 ? `0${max.hours()}` : max.hours()
              }:${max.minutes() < 10 ? `0${max.minutes()}` : max.minutes()}`
              if (value > max)
                return setError(
                  `Maximum duration for this session is ${maxDuration}`
                )

              if (value.asMinutes() !== duration + overtime)
                Heap.trigger('Classroom Feedback Duration - Submit - Different')

              onSubmit(value.asMinutes())
            }
          }}
        />
      </div>
    </div>
  )
}

export default Duration
